/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { UtrvStatus } from '../../constants/status';
import SimpleTooltip from '../simple-tooltip';
import React from 'react';
import { EvidenceFile } from '../survey/question/questionInterfaces';

interface ToggleIconProps {
  i: number;
  allowToggle?: boolean;
  saving?: boolean;
  toggleFile: (i: number, file: EvidenceFile) => void;
  file: EvidenceFile;
}

export function ToggleIcon(props: ToggleIconProps) {
  const { i, allowToggle = false, saving = false, toggleFile, file } = props;

  const isDeleted = '_id' in file && file.isDeleted;
  const evidenceTick = isDeleted ? 'evidence-deleted' : 'evidence-tick';
  const status = '_id' in file ? file.status ?? '' : '';

  const canDelete = (!('_id' in file) || file.status === UtrvStatus.Updated);

  if (allowToggle && canDelete) {
    const text = isDeleted ? 'Click to undo remove evidence' : 'Click to remove evidence';
    return <SimpleTooltip className='text-center' text={text}>
      <i style={{ cursor: saving ? 'not-allowed' : 'default' }}
        onClick={() => !saving && toggleFile(i, file)}
        className={`utrv-status ${status} fa ${evidenceTick}`} />
    </SimpleTooltip>
  }

  return <SimpleTooltip text={'You are not allowed to remove this evidence item'}>
    <i style={{ cursor: 'not-allowed' }} className={`utrv-status ${status} fa ${evidenceTick}`} />
  </SimpleTooltip>;
}
